module.exports = __webpack_public_path__ + "static/media/brands-06-jenos-pizza@2x.175e42e2.png";